module.exports = __webpack_public_path__ + "img/img-a5266524.3e3a4e84.png";